import usePermissions from "../../hooks/usePermissions";
import {
  ALL_MODULES,
  ALL_ACTIONS
} from "../../utils/permissionHelpers";


export default function PermissionMatrix({ roleId }) {

  const {
    permissionMap,
    loading,
    dirty,
    togglePermission,
    savePermissions
  } = usePermissions(roleId);

  if (!roleId) {
    return <p>Select a role to manage permissions.</p>;
  }

  if (loading) {
    return <p>Loading permissions...</p>;
  }

  return (
    <div className="pm-container">

      <table className="pm-table">
        <thead>
          <tr>
            <th>Module</th>
            {ALL_ACTIONS.map(action => (
              <th key={action}>{action}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {ALL_MODULES.map(module => (
            <tr key={module}>
              <td className="pm-module">{module}</td>

              {ALL_ACTIONS.map(action => {

                const checked =
                  permissionMap[module]?.includes(action);

                return (
                  <td key={action}>
                    <input
                      type="checkbox"
                      checked={!!checked}
                      onChange={() =>
                        togglePermission(module, action)
                      }
                    />
                  </td>
                );
              })}

            </tr>
          ))}
        </tbody>
      </table>

      {dirty && (
        <div className="pm-savebar">
          <button onClick={savePermissions}>
            Save Changes
          </button>
        </div>
      )}
<style>{`.pm-container {
  display: flex;
  flex-direction: column;
}

.pm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.pm-table th,
.pm-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.pm-module {
  font-weight: 600;
  text-align: left;
}

.pm-savebar {
  margin-top: 12px;
  text-align: right;
}`}</style>
    </div>

  );
}